import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { allPass, equals } from 'ramda';

import { valueAccessorFactory } from '../../../helpers';
import { KeyDownListenerService, OutsideClickListenerService } from '../../../providers';
import { DomHandler } from '../../../services';
import { hasNoValue, hasValue, isNotNil, isOneOf, KeyCode } from '../../../util';
import { formControlFactory } from '../../form-control.provider';
import { BaseSelectDirective } from '../base-select.directive';
import { selectProviderFactory } from '../with-select-provider';

const DEFAULT_VALUE = null;

@Component({
  selector: 'pcs-single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.scss'],
  providers: [
    valueAccessorFactory(SingleSelectComponent),
    KeyDownListenerService,
    OutsideClickListenerService,
    selectProviderFactory(SingleSelectComponent),
    formControlFactory(SingleSelectComponent)
  ]
})
export class SingleSelectComponent extends BaseSelectDirective implements OnInit {

  @Input() selected: any = DEFAULT_VALUE;
  @Input() showFirstOption = true;
  @Input() container: 'body' | null = null;

  constructor(
    public translateService: TranslateService,
    public keyDownListener: KeyDownListenerService,
    public outsideClickListener: OutsideClickListenerService,
    public domHandler: DomHandler,
    public cd: ChangeDetectorRef
  ) {
    super(translateService, keyDownListener, outsideClickListener, domHandler, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  writeValue(value: any) {
    this.select(value);
  }

  select(option: any) {
    this.resetFocus();
    this.selected = option;
  }

  onFocus() {
    this.show();
    this.focused = true;
  }

  onBlur(event) {
    this.focused = false;
  }

  isSelected(option): boolean {
    const isSelected = equals(this.selected);

    return allPass([isNotNil, isSelected])(option);
  }

  selectFirstOption(): void {
    this.selectOption(null);
  }

  isFirstSelected(): boolean {
    return false;
  }

  onSelected() {
    this.updateFilter();
    this.hide();
  }

  onKeyDown(event: KeyboardEvent) {
    if (this.deleteEvent(event) && this.canDelete()) {
      this.deleteSelectedValue();
    } else {
      super.onKeyDown(event);
    }
  }

  getPlaceholder() {
    return hasValue(this.selected) ? this.getOptionValue(this.selected) : this.defaultPlaceholder();
  }

  private deleteEvent(event: KeyboardEvent): boolean {
    return isOneOf([KeyCode.Backspace, KeyCode.Delete], event);
  }

  private canDelete() {
    return hasValue(this.selected) && hasNoValue(this.searchTerm);
  }

  private deleteSelectedValue() {
    this.selected = DEFAULT_VALUE;
    this.propagateChange(this.selected);
    this.propagateTouched(this.selected);
    this.selectionChanged.emit(this.selected);
  }
}
